// import * as types from '../actions/actionTypes';
import { BYPASS_LOADER_KEY } from 'constants/flowControlConstants';
import initialState from './initialState';
import { LOADING } from '../store/constants';

const reducer = (state = initialState[LOADING], action) => {
  if (action.meta === undefined) return state;

  const { meta } = action;
  const { fingerprint } = meta;
  const bypassLoader = meta[BYPASS_LOADER_KEY];
  if (!fingerprint || bypassLoader) return state;

  const isRequestAction = action.type.endsWith('REQUEST');
  return {
    ...state,
    [fingerprint]: isRequestAction
  };
};

export default reducer;
